import { api } from '@/core/api/';

const URL = 'api/disbursementrequest';

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const getCenters = () => api.get(`${URL}/centers`);

export const getDisbursementRequests = async (filters) => {
  return await api.get(`${URL}/search`, {
    params: {
      ...filters,
    },
  });
};

export const getRequestDetails = (requestId) =>
  api.get(`${URL}/details/${requestId}`);

export const getDetailsByTapRequest = (requestId) =>
  api.get(`${URL}/detailstaprequest/${requestId}`);

export const getTrackingHistory = (parameters) =>
  api.get(`${URL}/trackinghistory`, {
    params: {
      ...parameters,
    },
  });

export const uploadOrUpdateFile = (payload) =>
  api.post(`${URL}/uploadorupdatedisbursementdocument`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getAvailableStatuses = (requestId) =>
  api.get(`${URL}/availablestatuses/${requestId}`);

export const switchStatus = (payload) =>
  api.post(`${URL}/switchdisbursementrequeststatus`, payload);

export const getStudent = (requestId) =>
  api.get(`${URL}/getstudent/${requestId}`);
export const getInitFiltersCreateTap = () =>
  api.get(`${URL}/createtaprequestinitfilters`);
export const createConversionTapRequest = (payload) =>
  api.post(`${URL}/createconversiontaprequest`, payload);
export const submitRequest = (payload) =>
  api.post(`${URL}/submit`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const saveAdjustment = (payload) =>
  api.post(`${URL}/saveadjustment`, payload);

export const getAdjustmentHistory = (parameters) =>
  api.get(`${URL}/adjustmenthistory`, {
    params: {
      ...parameters,
    },
  });

export const deleteAdjustment = (requestAdjustmentId) =>
  api.delete(`${URL}/deleteadjustment/${requestAdjustmentId}`);

export const editAdjustment = (payload) =>
  api.put(`${URL}/editadjustment`, payload);

export const getTapRequest = ({ number, academicYearId, requestType }) =>
  api.get(`${URL}/taprequest/${number}/${academicYearId}/${requestType}`);
export const searchTaprequest = (params) =>
  api.get(`${URL}/searchtaprequest`, {
    params: params,
  });

export const saveDisbursement = (payload) => api.post(`${URL}/save`, payload);

export const savePartialRequest = (parameters) =>
  api.post(`${URL}/save/partial`, parameters);

export const getDigitNumbers = (year) => api.get(`${URL}/digitnumbers/${year}`);

export const getSIFDERegistrationDocument = () =>
  api.get(`${URL}/sifderegistrydocument`);

export const updateReimbursementVoucherStatus = (voucherId) =>
  api.get(`${URL}/updatereimbursementvoucherstatus`, {
    params: {
      voucherId,
    },
  });

export const getVisitCertificationDirectPayment = async (payload) => {
  return await api.post(`api/report/visitcertificationdirectpayment`, payload);
};

export const processBulkPayment = (parameters) =>
  api.post(`${URL}/processbulkpayment`, parameters);

export const createAdditionalPayment = (requestId) =>
  api.get(`${URL}/createadditionalpayment/${requestId}`);

export const getServicesByPeriod = (studentSieId, month, year) =>
  api.get(`${URL}/getservicesbyperiod/${studentSieId}/${month}/${year}`);

export const getBlockedPeriods = (studentSieId, requestId) =>
  api.get(`${URL}/getblockedperiods/${studentSieId}/${requestId}`);

export const aiValidateRequest = (requestId) =>
  api.get(`${URL}/aivalidaterequest?requestId=${requestId}`);

export const saveDisbursementRequestMechanism = (
  requestId,
  isElectronicSignature
) =>
  api.post(
    `${URL}/savedisbursementrequestmechanism/${requestId}?isElectronicSignature=${isElectronicSignature}`
  );

export const getSignRefundCertificationUrl = (requestId) =>
  api.get(`${URL}/signrefundcertificationurl/${requestId}`);

export const getRefundReimbursementReport = (requestId) =>
  api.get(`api/report/refund-reimbursement/${requestId}`);
